// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BusinessLoadAllResponse

import { FeatureFlag } from './enums.gen';
import { hydrateActivity, type Activity, type ActivityApiResponse } from './activity.gen';
import { hydrateSession, type Session, type SessionApiResponse } from './session.gen';
import { hydrateArea, type Area, type AreaApiResponse } from './area.gen';
import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';
import { hydrateOfferCollection, type OfferCollection, type OfferCollectionApiResponse } from './offerCollection.gen';
import { hydrateOpeningHour, type OpeningHour, type OpeningHourApiResponse } from './openingHour.gen';
import { hydrateUserNotificationSetting, type UserNotificationSetting, type UserNotificationSettingApiResponse } from './userNotificationSetting.gen';
import { hydrateBookableGiftcard, type BookableGiftcard, type BookableGiftcardApiResponse } from './bookableGiftcard.gen';
import { hydrateOpeningHourException, type OpeningHourException, type OpeningHourExceptionApiResponse } from './openingHourException.gen';
import { hydrateBlockingPeriod, type BlockingPeriod, type BlockingPeriodApiResponse } from './blockingPeriod.gen';
import { hydrateGiftcard, type Giftcard, type GiftcardApiResponse } from './giftcard.gen';
import { hydrateCustomField, type CustomField, type CustomFieldApiResponse } from './customField.gen';
import { hydrateSmsPack, type SmsPack, type SmsPackApiResponse } from './smsPack.gen';
import { hydrateQrCodeScan, type QrCodeScan, type QrCodeScanApiResponse } from './qrCodeScan.gen';
import { hydrateGoogleCalendar, type GoogleCalendar, type GoogleCalendarApiResponse } from './googleCalendar.gen';
import { hydrateGoogleAuth, type GoogleAuth, type GoogleAuthApiResponse } from './googleAuth.gen';
import { hydratePromoCode, type PromoCode, type PromoCodeApiResponse } from './promoCode.gen';
import { hydratePackage, type Package, type PackageApiResponse } from './package.gen';
import { hydrateCustomerPackage, type CustomerPackage, type CustomerPackageApiResponse } from './customerPackage.gen';
import { hydrateProduct, type Product, type ProductApiResponse } from './product.gen';
import { hydrateMemo, type Memo, type MemoApiResponse } from './memo.gen';
import { hydrateBookingEvent, type BookingEvent, type BookingEventApiResponse } from './bookingEvent.gen';
import { hydrateReleaseNote, type ReleaseNote, type ReleaseNoteApiResponse } from './releaseNote.gen';
import { hydrateBusiness, type Business, type BusinessApiResponse } from './business.gen';
import { hydrateContract, type Contract, type ContractApiResponse } from './contract.gen';
import { hydrateAgendaSetting, type AgendaSetting, type AgendaSettingApiResponse } from './agendaSetting.gen';
import { hydrateEmailSettings, type EmailSettings, type EmailSettingsApiResponse } from './emailSettings.gen';
import { hydrateNotificationStats, type NotificationStats, type NotificationStatsApiResponse } from './notificationStats.gen';
import { hydrateSmsSettings, type SmsSettings, type SmsSettingsApiResponse } from './smsSettings.gen';

export type BusinessLoadAllApiResponse = {
	activities: ActivityApiResponse[];
	sessions: SessionApiResponse[];
	areas: AreaApiResponse[];
	offers: OfferApiResponse[];
	offerCollections: OfferCollectionApiResponse[];
	openingHours: OpeningHourApiResponse[];
	tags: Array<string>;
	features: FeatureFlag[];
	notificationSettings: Record<string, UserNotificationSettingApiResponse>;
	bookableGiftcards: BookableGiftcardApiResponse[];
	openingHourExceptions: OpeningHourExceptionApiResponse[];
	blockingPeriods: BlockingPeriodApiResponse[];
	giftcardStats: { sold: number; income: number; remaining: number };
	giftcards: GiftcardApiResponse[];
	customFields: CustomFieldApiResponse[];
	smsPacks: SmsPackApiResponse[];
	scans: QrCodeScanApiResponse[];
	featuresVotes: Array<{ feature: string; vote: boolean }>;
	featuresClicked: Array<{ feature: string; clicks: number }>;
	googleCalendars: GoogleCalendarApiResponse[];
	googleAuths: GoogleAuthApiResponse[];
	promoCodes: PromoCodeApiResponse[];
	packages: PackageApiResponse[];
	customerPackages: CustomerPackageApiResponse[];
	products: ProductApiResponse[];
	memos: MemoApiResponse[];
	bookingEvents: BookingEventApiResponse[];
	releaseNotes: ReleaseNoteApiResponse[];
	business: BusinessApiResponse;
	contract: ContractApiResponse;
	agendaSettings: AgendaSettingApiResponse;
	emailSettings: EmailSettingsApiResponse;
	notificationStats: NotificationStatsApiResponse;
	socketToken: string;
	smsSettings: SmsSettingsApiResponse | null;
};

export type BusinessLoadAll = {
	activities: Activity[];
	sessions: Session[];
	areas: Area[];
	offers: Offer[];
	offerCollections: OfferCollection[];
	openingHours: OpeningHour[];
	tags: Array<string>;
	features: FeatureFlag[];
	notificationSettings: Record<string, UserNotificationSetting>;
	bookableGiftcards: BookableGiftcard[];
	openingHourExceptions: OpeningHourException[];
	blockingPeriods: BlockingPeriod[];
	giftcardStats: { sold: number; income: number; remaining: number };
	giftcards: Giftcard[];
	customFields: CustomField[];
	smsPacks: SmsPack[];
	scans: QrCodeScan[];
	featuresVotes: Array<{ feature: string; vote: boolean }>;
	featuresClicked: Array<{ feature: string; clicks: number }>;
	googleCalendars: GoogleCalendar[];
	googleAuths: GoogleAuth[];
	promoCodes: PromoCode[];
	packages: Package[];
	customerPackages: CustomerPackage[];
	products: Product[];
	memos: Memo[];
	bookingEvents: BookingEvent[];
	releaseNotes: ReleaseNote[];
	business: Business;
	contract: Contract;
	agendaSettings: AgendaSetting;
	emailSettings: EmailSettings;
	notificationStats: NotificationStats;
	socketToken: string;
	smsSettings: SmsSettings | null;
};

export function hydrateBusinessLoadAll(data: BusinessLoadAllApiResponse): BusinessLoadAll {
	return {
		...data,
		activities: data.activities.map(hydrateActivity),
		sessions: data.sessions.map(hydrateSession),
		areas: data.areas.map(hydrateArea),
		offers: data.offers.map(hydrateOffer),
		offerCollections: data.offerCollections.map(hydrateOfferCollection),
		openingHours: data.openingHours.map(hydrateOpeningHour),
		notificationSettings: !data.notificationSettings || Array.isArray(data.notificationSettings) ? {} : Object.fromEntries(Object.entries(data.notificationSettings).map(([k, v]) => [k, hydrateUserNotificationSetting(v)])),
		bookableGiftcards: data.bookableGiftcards.map(hydrateBookableGiftcard),
		openingHourExceptions: data.openingHourExceptions.map(hydrateOpeningHourException),
		blockingPeriods: data.blockingPeriods.map(hydrateBlockingPeriod),
		giftcards: data.giftcards.map(hydrateGiftcard),
		customFields: data.customFields.map(hydrateCustomField),
		smsPacks: data.smsPacks.map(hydrateSmsPack),
		scans: data.scans.map(hydrateQrCodeScan),
		googleCalendars: data.googleCalendars.map(hydrateGoogleCalendar),
		googleAuths: data.googleAuths.map(hydrateGoogleAuth),
		promoCodes: data.promoCodes.map(hydratePromoCode),
		packages: data.packages.map(hydratePackage),
		customerPackages: data.customerPackages.map(hydrateCustomerPackage),
		products: data.products.map(hydrateProduct),
		memos: data.memos.map(hydrateMemo),
		bookingEvents: data.bookingEvents.map(hydrateBookingEvent),
		releaseNotes: data.releaseNotes.map(hydrateReleaseNote),
		business: hydrateBusiness(data.business),
		contract: hydrateContract(data.contract),
		agendaSettings: hydrateAgendaSetting(data.agendaSettings),
		emailSettings: hydrateEmailSettings(data.emailSettings),
		notificationStats: hydrateNotificationStats(data.notificationStats),
		smsSettings: data.smsSettings ? hydrateSmsSettings(data.smsSettings) : null,
	};
}